import { Box } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';
import { textDisabled } from 'styles/theme';

const borderColor = '#E3E8F0'

export const AchievementGraphStyles = muiStyled(Box)(() => ({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    rowGap: 16,

    // ── Bar colors (cascade down into BarLine) ──
    '.expected-rating-line': {
        background: "#E4F2D1",
        color: "#50B02B",
    },
    '.unexpected-rating-line': {
        background: "#FBD9DA",
        color: "#FF9B9B",
    },

    // ── Header classes ──
    '.bar-lines-header': {
        display: 'flex',
        flexDirection: 'column',
        rowGap: 7,
    },
    '.bar-line-filters': {
        display: 'flex',
        justifyContent: 'space-between',
        columnGap: 10,
        alignItems: 'center',
    },
    '.compare-label-group': {
        display: 'flex',
        alignItems: 'center',
        columnGap: 10,
    },
    '.compare-label': {
        fontSize: 19,
        fontWeight: 'bold',
    },
    '.flex': {
        display: 'flex',
        alignItems: 'center',
        columnGap: 10,
    },
    '.profiles': {
        display: 'flex',
        columnGap: 15,
        alignItems: 'center',
    },
    '.select-segmentation': {
        '.MuiOutlinedInput-notchedOutline': {
            borderStyle: 'dashed !important',
        },
    },
    // Remove gap between school rows — borders handle the separation
    '.bar-line-container': {
        rowGap: '0 !important',
        border: `1px solid ${borderColor}`,
    },

    // ── One school group (N semester rows) ──
    '.progress-school-group': {
        alignItems: 'stretch !important',  // fill full height so separator border runs end-to-end
        columnGap: '0 !important',
        borderBottom: `1px solid ${borderColor}`,
        '&:last-child': {
            borderBottom: 'none',
        },
    },

    // ── School name column (RTL: physical right) ──
    '.progress-school-info': {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        rowGap: 4,
        paddingRight: 16,
        paddingLeft: 12,
    },
    // High-specificity rule to guarantee the separator renders
    '.progress-school-group .progress-school-info': {
        borderLeft: `1px solid ${borderColor}`,
    },
    '.progress-school-info .layout-label': {
        // fontWeight: 700,
        flexGrow: 0,
    },
    '.progress-improvement': {
        fontSize: 12,
        fontWeight: 500,
        '&.positive': { color: '#4F6F0E' },
        '&.negative': { color: '#FF0000' },
    },

    // ── Bars column (RTL: physical left) ──
    '.progress-school-bars': {
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        paddingTop: 10,
        paddingBottom: 10,
        // הפרדה ברורה בין שורת "מבדק ראשון" ל"מבדק אחרון" — כדי שהסיכום
        // "תוצאות של X תלמידים" ייקרא כשייך לבר שמעליו ולא לבר שמתחתיו
        rowGap: 14,
    },

    // ── Single semester row ──
    '.progress-combo-row': {
        display: 'flex',
        alignItems: 'center',
        flexGrow: 1,
        // בתוך BarLine (הילד האחרון בשורה) — הצמדת שורת הסיכום לבר שלה (8→3)
        '& > *:last-child': { rowGap: 3 },
    },

    // ── Semester tag — ALL IN ONE ROW: [name] [users icon] [← arrow] ──
    '.progress-semester-tag': {
        width: 150,
        minWidth: 150,
        flexShrink: 0,
        display: 'flex',
        flexDirection: 'row',         // horizontal: label + icon + arrow side by side
        alignItems: 'center',
        justifyContent: 'flex-end',
        columnGap: 6,
        paddingInline: '8px 12px',
    },
    '.progress-semester-name': {
        // fontWeight: 700,
        fontSize: 14,
        color: '#404F69',
        whiteSpace: 'nowrap',
        flex: 1,
    },
    '.semester-info-icon': {
        fontSize: 13,
        color: textDisabled,
        cursor: 'pointer',
        flexShrink: 0,
        '&:hover': { color: '#555' },
    },
    '.chevron-icon': {
        fontSize: 12,
        color: textDisabled,
        flexShrink: 0,
    },

    '.progress-no-data': {
        flexGrow: 1,
        display: 'flex',
        alignItems: 'center',
        color: textDisabled,
        fontSize: '16px',
        minHeight: 64,
    },
}));
